import { Props } from ".../../../types/field";
import {
  Box,
  Button,
  FormLabel,
  Heading,
  Input,
  Select,
  SimpleGrid,
  useToast
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { authHeader, fetchWithMiddleware } from "../../../../utils/utils";
import { UrlConstants } from "../../../../utils/ApiConstants";
import dayjs from "dayjs";
import { Checkbox, DatePicker, Radio, RadioChangeEvent, Typography } from "antd";
import { useSelector } from "react-redux";
import { GetRequest } from "../../../../utils/api";
import { ChakraProvider } from "@chakra-ui/react";

interface PaymentModeOptionsStruct {
  paymentModeCode: string;
  paymentMode: string;
  id: number;
}

interface Record {
  platformPojoKey: string;
  originalAmt: number;
  loanNo: string;
  componentCode: number;
  validDate: string;
  id: number;
}

// interface Data {
//   records: Record[];
// }

interface OnlineSettlementProps extends Props {
  loanNo: string;
}

const OnlineWaiverSettlement: React.FC<OnlineSettlementProps> = ({ title, loanNo }) => {

  const { state } = useLocation();

  if (state && state.loanNo) {
    loanNo = state.loanNo
  }

  const rootState = useSelector((state: any) => state?.userReducer);
  const [blueprint, setBlueprint] = useState<any>();
  // const [customerName, setCustomerName] = useState<string>();
  // const [customerWaiverDues, setCustomerWaiverDues] = useState<any>();
  const [platformPojoMap, setPlatformPojoMap] = useState(new Map());

  const [loanDetails, setLoanDetails] = useState<any>({});
  const [totalDues, setTotalDues] = useState<number>();
  const [paymentModeOptions, setPaymentModeOptions] =
    useState<PaymentModeOptionsStruct[]>();
  const [paymentModeCount, setPaymentModeCount] = useState<any>();
  const [settlementType, setSettlementType] = useState<string>('closure');
  const [termsAndConditionsAccepted, setTermsAndConditionsAccepted] = useState<boolean>(false);
  const toast = useToast();
  const [
    showInvalidSettlementAmountError,
    setShowInvalidSettlementAmountError,
  ] = useState<boolean>(false);
  const [canGenerateSettlementLetter, setCanGenerateSettlementLetter] =
    useState<boolean>(false);
  const [searchData, setSearchData] = useState({
    loanNo: "",
    settlementType: "closure",
    termsAndConditionsAccepted: termsAndConditionsAccepted,
    settlementAmount: undefined,
    paymentMode: undefined,
    paymentDates: [] as string[],
    installmentAmounts: [] as number[],
  });
  // const [value, setValue] = React.useState("");
  let {
    externalUserInfo: { data: externalUserInfo },
  } = rootState || {};

  const termsAndConditions = [
    'By accessing and using this website, you agree to be bound by the following terms and conditions.',
    'The content of this website is for general information purposes only. It is subject to change without notice.',
    'We reserve the right to modify these terms and conditions at any time without notice. It is your responsibility to review these terms and conditions periodically.'
  ];

  const { Text } = Typography;

  const handleSearchInputChange = (event: any, fieldName: keyof typeof searchData, index?: number) => {
    console.log("Value changed: ", event.target.value, "Field ....", fieldName);
    setCanGenerateSettlementLetter(false);
    if (fieldName === "paymentMode") {
      console.log(event.target);
      searchData.paymentDates = [];
      searchData.installmentAmounts = [];
      if (event.target.value === '004') {
        setPaymentModeCount(6);
      } else {
        setPaymentModeCount(parseInt(event.target.value));
      }
    }

    const { value } = event.target;

    if (index !== undefined) {
      setSearchData((prevData) => {
        if (fieldName === "installmentAmounts") {
          const dataToBeUpdated = [...(prevData[fieldName] as number[])];; // Copy the array
          dataToBeUpdated[index] = value; // Replace the value at the specified index

          return {
            ...prevData,
            installmentAmounts: dataToBeUpdated, // Update the state with the new array
          };
        } else if (fieldName === "paymentDates") {
          const dataToBeUpdated = [...(prevData[fieldName] as string[])];; // Copy the array
          dataToBeUpdated[index] = value; // Replace the value at the specified index

          return {
            ...prevData,
            paymentDates: dataToBeUpdated, // Update the state with the new array
          };
        } else {
          return { ...prevData }
        }
      });
    } else {
      setSearchData((prevData) => ({
        ...prevData,
        [fieldName]: value,
      }));
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      await fetchCustomerLoanDetails();
      await fetchBlueprint();
      await fetchOnlineSettlementPaymentMode();
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (externalUserInfo?.campaignId) {
      trackUserLocationIfRequired(externalUserInfo?.campaignId);
    }
  }, [externalUserInfo]);


  const fetchOnlineSettlementPaymentMode = async () => {
    const url = `${UrlConstants.BASE_URL}reposession-waiver/platform/api/online-settlement-payment-mode-master?size=10&page=0`;

    fetchWithMiddleware(url, {
      headers: {
        Authorization: authHeader().Authorization,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Process the received data

        setPaymentModeOptions(data.records);
      })
      .catch((error) => {
        // Handle any errors
        console.error(error);
      });
  };


  const fetchCustomerLoanDetails = async () => {
    // Here we should subscribe to notifications
    const url = `${UrlConstants.BASE_URL}loan/platform/api/loanDetails/${loanNo}`;

    fetchWithMiddleware(url, {
      headers: {
        Authorization: authHeader().Authorization,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Process the received data
        setLoanDetails(data);
      })
      .catch((error) => {
        // Handle any errors
        console.error(error);
      });
  };

  const trackUserLocationIfRequired = async (campaignId: string) => {
    const url = `${UrlConstants.BASE_URL}auth/platform/api/online-settlement-campaign/${campaignId}`;

    fetchWithMiddleware(url, {
      headers: {
        Authorization: authHeader().Authorization
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.trackUsersLocation) {
          // track users location
          navigator.geolocation.getCurrentPosition(
            position => {
              const { latitude, longitude } = position.coords;
              saveLocation(latitude, longitude, campaignId); // Make API call to save location
            },
            error => {
              console.log("Failed to persist the user loaction:" + error.message);
            }
          );
        }
      })
      .catch((error) => {
        // Handle any errors
        console.error(error);
      });
  }

  const saveLocation = async (latitude: any, longitude: any, campaignId: any) => {
    try {
      const url = `${UrlConstants.BASE_URL}auth/platform/api/users-login-location`;
      const response = await fetchWithMiddleware(url, {
        method: 'POST',
        headers: {
          Authorization: authHeader().Authorization,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ latitude, longitude, "campaignCode": campaignId }),
      });
      if (!response.ok) {
        throw new Error('Failed to save location');
      }
    } catch (error) {
      console.log("Failed to persist the user loaction:" + JSON.stringify(error));
    }
  };


  useEffect(() => {
    if (blueprint?.editForm && loanDetails) {
      const totalDues = blueprint.editForm.filter((field: any) => !['loanNo', 'customerName', 'totalDues', 'totalPrincipalOutstanding'].includes(field.field))
        .reduce((sum: number, field: any) => sum + (isNaN(loanDetails[field.field]) ? 0 : loanDetails[field.field] ?? 0), 0);

      setTotalDues(totalDues);

      blueprint.editForm.filter((field: any) => !['loanNo', 'customerName', 'totalDues', 'totalPrincipalOutstanding'].includes(field.field) && field.rules[0]?.allowValues === 'onlyNumeric')
        .forEach((field: any) => {
          platformPojoMap.set(field.field, loanDetails[field.field] ?? 0);
        });
    }
  }, [blueprint, loanDetails]);

  const fetchBlueprint = async () => {
    // Here we should subscribe to notifications
    const url = 'reposession-waiver/blueprint/onlineWaiverSettlement';

    GetRequest(url).then((res: any) => {
      setBlueprint(res);
    })
  };

  const getValue = (field: string) => {
    if (field === 'totalDues') {
      return totalDues;
    } else if (field === 'totalPrincipalOutstanding') {
      return (loanDetails['overduePrincipal'] ?? 0) + (loanDetails['futurePrincipal'] ?? 0);
    }
    return loanDetails[field];
  };

  const generateSettlementLetter = () => {
    const payload: any = {};
    for (const [key, value] of platformPojoMap) {
      payload[key] = value;
    }
    payload["loanNo"] = loanNo;
    payload["settlementAmt"] = searchData.settlementAmount;
    payload["totalDues"] = totalDues;
    payload["paymentMode"] = searchData.paymentMode;
    payload["termsAndConditionsAccepted"] = termsAndConditionsAccepted;
    payload["settlementType"] = settlementType;

    if (!termsAndConditionsAccepted) {
      toast({
        title: "Please accept the terms and conditions to generate the Letter.",
        position: "top",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    if (searchData.paymentDates) {
      let installments: any[] = [];
      searchData.paymentDates.forEach((date, index) => installments.push({ "paymentDate": date, "amount": searchData.installmentAmounts[index] ?? 0 }));
      payload["installmentDetails"] = installments;
    }

    const compositePayload = { "onlineSettlementDetails": [payload] };

    const url = `${UrlConstants.BASE_URL}reposession-waiver/online/settlement`;

    fetchWithMiddleware(url, {
      method: "POST",
      headers: {
        Authorization: authHeader().Authorization,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(compositePayload),
    })
      .then((data) => {
        // Process the received data
        if (data.status == 200) {
          toast({
            title: "Letter Generated.",
            position: "top",
            description: "Letter has been sent to Registered email.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        }
      })
      .catch((error) => {
        // Handle any errors
        console.error(error);
      });
  };

  const validateMinimumSettlementAmount = async () => {
    setShowInvalidSettlementAmountError(false);
    setCanGenerateSettlementLetter(false);

    if (
      !loanNo ||
      !searchData.settlementAmount ||
      !searchData.paymentMode
    ) {
      toast({
        title: "Mandatory data missing for validating Proposed amount.",
        position: "top",
        description:
          "[loanNumber | SettlementAmount | paymentMode]",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    if (settlementType === 'closure' && totalDues !== parseInt(searchData.settlementAmount)) {
      toast({
        title: "Proposed amount should match with total dues for Closure",
        position: "top",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    if (settlementType === 'settlement' && totalDues! < parseInt(searchData.settlementAmount)) {
      toast({
        title: "Settlement amount should not be greater than total Dues.",
        position: "top",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    let allValidationsPassed = await validateMinSettlementAmount();
    if (!allValidationsPassed) {
      return;
    }

    if (paymentModeCount > 1) {
      // Make sure we have input respective payment dates and installment amount selected.
      if (searchData.paymentDates.length < paymentModeCount || searchData.installmentAmounts < paymentModeCount) {
        toast({
          title: "Payment Dates | Installment Amounts not filled",
          position: "top",
          description:
            "Payment Mode greater than single installment, Please fill respective Payment dates and Installment Amounts",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
        return;
      }
      const totalInstallmentAmounts = searchData.installmentAmounts.reduce((sum, amount) => sum + +amount, 0);
      if (totalInstallmentAmounts !== +searchData.settlementAmount) {
        toast({
          title: "Installment Amounts should add upto Proposed amount",
          position: "top",
          description:
            "Installment amount doesn't sum upto Proposed Amount, they should match \n ",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
        return;
      }
    }

    if (allValidationsPassed) {
      toast({
        title: "Proposed Amount Approved!.",
        position: "top",
        description:
          "Thank you for submitting the request. Letter can be generated now.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
      setCanGenerateSettlementLetter(true);
    }

  };

  const validateMinSettlementAmount = async (): Promise<boolean> => {
    const url = `${UrlConstants.BASE_URL}reposession-waiver/online/allowedsettlement`;
    const requestBody = {
      loanNumber: loanNo,
      settlementAmount: searchData.settlementAmount,
      campaignId: externalUserInfo?.campaignId,
      totalDues: totalDues,
      noOfInstallments: paymentModeCount
    };
    let validationPassed = false;
    await fetchWithMiddleware(url, {
      method: "POST",
      headers: {
        Authorization: authHeader().Authorization,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => {
        if (!response.ok) {
          response.json().then(data => {
            toast({
              title: "Invalid Proposed Amount.",
              position: "top",
              description:
                data.errorMessage ?? "test",
              status: "warning",
              duration: 9000,
              isClosable: true,
            });
          });
        } else {
          validationPassed = true;
        }
      })
      .catch((error) => {
        // Handle any errors
        console.error(error);
      });

    return validationPassed;
  }

  const disabledDate = (current: number | dayjs.Dayjs) => {
    return !(
      current < dayjs().add(7, "day") &&
      current > dayjs().subtract(1, "day")
    );
  };

  const allowFutureDates = (current: number | dayjs.Dayjs) => {
    return current < dayjs().add(0, "day");
  };

  return (
    <ChakraProvider>
      <div>
        <Box>
          <Heading>Online Settlement</Heading>
          <div style={{ marginTop: "15px", marginLeft: "10px" }}>
            <Radio.Group name="settlementType" onChange={(e: RadioChangeEvent) => { setSettlementType(e.target?.value); }}
              value={settlementType}>
              <Radio key={0} value={"closure"}>
                {"Closure"}
              </Radio>
              <Radio key={1} value={"settlement"}>
                {"Settlement"}
              </Radio>
            </Radio.Group>
          </div>
          <SimpleGrid columns={4} spacing={4} padding={3}>
            {blueprint && blueprint.editForm && (
              <>
                {blueprint.editForm.map((field: any) => (
                  <>
                    <Box key={field.field}>
                      <FormLabel htmlFor={field.field}>
                        {field.displayName}
                      </FormLabel>
                      {field.fieldType === "textBox" && (
                        <Input
                          type="text"
                          id={field.field}
                          name={field.field}
                          placeholder={field.placeholder}
                          value={getValue(field.field)}
                          isDisabled={!field.editable}
                          style={
                            !field.editable
                              ? {
                                backgroundColor: "#E2E8F0",
                                color: "#333",
                                opacity: "1",
                              }
                              : {}
                          }
                        />
                      )}
                      {field.fieldType === "select" && (
                        <Select
                          id={field.field}
                          placeholder="Select"
                          value={searchData.paymentMode}
                          onChange={(e) =>
                            handleSearchInputChange(e, "paymentMode")
                          }
                        >
                          {paymentModeOptions?.map((option) => (
                            <option
                              key={option.id}
                              value={option.paymentModeCode}
                            >
                              {option.paymentMode}
                            </option>
                          ))}
                        </Select>
                      )}
                      {field.fieldType === "number" && (
                        <Input
                          id={field.field}
                          type="number"
                          placeholder={field.placeholder}
                          value={searchData.settlementAmount}
                          onChange={(e) =>
                            handleSearchInputChange(e, "settlementAmount")
                          }
                        />
                      )}
                      {/* Add more conditionals for other field types */}
                    </Box>
                  </>
                ))}
              </>
            )}
          </SimpleGrid>
          <SimpleGrid
            columns={1}
            spacing={2}
            p={3}
            border="1px solid rgb(59 130 246 / 0.5)"
            margin={2}
          >
            {/* First row */}
            <Box>
              <SimpleGrid columns={2} spacing={2}>
                <Box>
                  <FormLabel htmlFor={"paymentMode"}>Repayment Plan</FormLabel>
                  <Select
                    id="paymentMode"
                    placeholder="Select"
                    value={searchData.paymentMode}
                    onChange={(e) => handleSearchInputChange(e, "paymentMode")}
                  >
                    {paymentModeOptions?.map((option) => (
                      <option key={option.id} value={option.paymentModeCode}>
                        {option.paymentMode}
                      </option>
                    ))}
                  </Select>
                </Box>
                <Box>
                  <FormLabel htmlFor={"settlementAmount"}>
                    Proposed Amount
                  </FormLabel>
                  <Input
                    id="settlementAmount"
                    type="number"
                    placeholder=""
                    value={searchData.settlementAmount}
                    onChange={(e) =>
                      handleSearchInputChange(e, "settlementAmount")
                    }
                  />
                </Box>
              </SimpleGrid>
            </Box>
            {paymentModeCount > 1 && (
              <Box>
                <SimpleGrid columns={2} spacingX={2} spacingY={4}>
                  {Array.from({ length: paymentModeCount }).map((_, index) => (
                    <React.Fragment key={index}>
                      <Box gridColumn={1} gridRow={index + 1}>
                        <FormLabel htmlFor={`paymentDate-${index}`}>
                          Installment Date {index + 1}
                        </FormLabel>
                        <DatePicker
                          style={{ width: "100%" }}
                          id={`paymentDate-${index}`}
                          placeholder=""
                          className="notranslate"
                          format={"DD-MMM-YYYY"}
                          disabledDate={index === 0 ? disabledDate : allowFutureDates}
                          onChange={(value: any) => {
                            let date = dayjs(value).format("YYYY-MM-DD");
                            searchData.paymentDates[index] = date;
                            handleSearchInputChange({ target: { value: date } }, "paymentDates", index);
                          }}

                        />
                      </Box>
                      <Box gridColumn={2} gridRow={index + 1}>
                        <FormLabel htmlFor={`installmentAmount-${index}`}>
                          Installment Amount {index + 1}
                        </FormLabel>
                        <Input
                          id={`installmentAmount-${index}`}
                          type="number"
                          placeholder=""
                          value={searchData.installmentAmounts[index] || ""}
                          onChange={(e) => handleSearchInputChange(e, "installmentAmounts", index)}
                        />
                      </Box>
                    </React.Fragment>
                  ))}
                </SimpleGrid>
              </Box>
            )}

            <div style={{ display: 'flex', justifyContent: 'start', marginTop: '80px' }}>
              <div>
                <Checkbox
                  checked={termsAndConditionsAccepted}
                  onChange={(e) => {
                    setTermsAndConditionsAccepted(e.target.checked);
                  }}
                />
              </div>
              <div style={{ marginLeft: '10px' }}>
                {termsAndConditions.map((item, index) => (
                  <div key={index}>
                    <Text type="secondary" style={{ fontSize: '12px' }}>
                      {`${index + 1}. `}
                    </Text>
                    <Text>{item}</Text>
                  </div>
                ))}
              </div>
            </div>

            {/* Second row */}
            <Box textAlign="right">
              <Button
                colorScheme="blue"
                variant="outline"
                onClick={validateMinimumSettlementAmount}
              >
                Accept
              </Button>
              {canGenerateSettlementLetter && (
                <Button
                  colorScheme="blue"
                  variant="outline"
                  ml={2}
                  onClick={generateSettlementLetter}
                >
                  Generate Letter
                </Button>
              )}
            </Box>
          </SimpleGrid>
        </Box >
      </div >

    </ChakraProvider>

  );
};

export default OnlineWaiverSettlement;
